import axios from "axios";
import React from 'react';
import {Cell, Div, FormItem, Spinner, SplitCol, SplitLayout} from "@vkontakte/vkui";
import * as constants from "../assets/constants";
import ProductsSmartAutocomplete from "./productsSmartAutocomplete";
import HelpButton from "../assets/HelpButton";
import BaseApi from "../api/BaseApi";


class ParamsList extends React.Component {
    state = {
        items: [],
        loading: false
    }

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        this.getItems()
    }

    getItems = () => {
        var body = new FormData()
        body.append('product_id', this.props.product.id)

        let sAjaxSource = '/?app=partnersproducts&act=getPartnerProductsPrefs';

        this.setState({
            items: [], loading: true
        });
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {

            this.setState({loading: false, items: response.data.items})


        })

    }


    render() {
        const {current_user} = this.props
        console.log(current_user)
        return (
            <Div>

                <SplitLayout style={{marginBottom: "50px"}}>

                    <SplitCol>
                        {this.state.loading ? <Cell after="Получаем свойства товара"><Spinner
                                size='large'></Spinner></Cell> :
                            this.state.items.map((item, index) => {
                                if (!(current_user
                                        && current_user['meta']
                                        && current_user['meta']['rules']
                                        && current_user['meta']['rules']['admin'])
                                    && item.title == 'Аналог характеристики'
                                ) {
                                    return
                                }
                                return <SplitLayout
                                    style={{fontSize: constants.AdaptivityContext.isMobile ? '13px' : 'inherit'}}>
                                    <SplitCol className="bordered bordered-reserves prefs-cell"
                                              style={{height: item.is_system == '1' ? '7vh' : 'inherit'}}
                                    >
                                        <FormItem aria-multiline>
                                            <div>{item.title}</div>

                                        </FormItem>
                                    </SplitCol>
                                    <SplitCol className={"bordered bordered-reserves"}
                                              style={{height: item.is_system == '1' ? '7vh' : 'inherit'}}>
                                        <FormItem>
                                            {item.title == 'Аналог характеристики' ?
                                                <ProductsSmartAutocomplete

                                                    current_user={current_user}

                                                    style={{minHeight: '33px'}}
                                                    noAutoOpen
                                                    placeholder="Поиск товара"
                                                    app="partnersproducts"
                                                    act="autocomplete"
                                                    params={`group=`}
                                                    default={item.value ?? null}
                                                    mode="outline"
                                                    size="s"
                                                    selectObject={async e => {
                                                        console.log(e)
                                                        await BaseApi.post('?app=partnersproducts&act=setOneProductPref',
                                                            {
                                                                product_id: this.props.product.id,
                                                                pref_name: 'Аналог характеристики',
                                                                pref_value: e.uid
                                                            })
                                                        this.getItems()
                                                    }}

                                                /> :
                                                item.value}
                                        </FormItem>
                                    </SplitCol>

                                </SplitLayout>
                            })
                        }
                    </SplitCol>

                </SplitLayout>
            </Div>
        )
    }

}

export default ParamsList